/**
 * @generated SignedSource<<b436c54c0cf6c7fc9f09ebdb9ad971cf>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionView_contractImport$data = {
  readonly collectionName: string | null;
  readonly contract: {
    readonly address: string | null;
    readonly name: string | null;
    readonly symbol: string | null;
  } | null;
  readonly contractAddress: {
    readonly address: string | null;
  } | null;
  readonly description: string | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionModal_contractImport" | "NftProfileImportCollectionViewToolbar_contractImport">;
  readonly " $fragmentType": "NftProfileImportCollectionView_contractImport";
};
export type NftProfileImportCollectionView_contractImport$key = {
  readonly " $data"?: NftProfileImportCollectionView_contractImport$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionView_contractImport">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftProfileImportCollectionView_contractImport",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileImportCollectionModal_contractImport"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileImportCollectionViewToolbar_contractImport"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "contractAddress",
      "plural": false,
      "selections": [
        (v0/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "collectionName",
      "storageKey": null
    },
    {
      "alias": "description",
      "args": null,
      "kind": "ScalarField",
      "name": "collectionDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftTokenContract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "symbol",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftTokenContractImport",
  "abstractKey": null
};
})();

(node as any).hash = "0be34bc7e7d8c2d31e578e88e7738d43";

export default node;
